import { render, staticRenderFns } from "./HsabExpenseCardRowRelationships.vue?vue&type=template&id=3c98a216&scoped=true"
import script from "./HsabExpenseCardRowRelationships.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseCardRowRelationships.vue?vue&type=script&lang=ts"
import style0 from "./HsabExpenseCardRowRelationships.vue?vue&type=style&index=0&id=3c98a216&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c98a216",
  null
  
)

export default component.exports